import React from 'react';
import {
  Box,
  Flex,
  Link as ChakraLink,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Button,
} from '@chakra-ui/react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { LogoMainImage } from '../../assets/icons/logo-main';
import { useAppDispatch, useAppSelector } from '../../../utils/reduxHooks';
import { setCarTypeAction } from '../../../modules/catalog/actions';
import { SearchBarWithResults } from '../searchByVINInput';
import { ChatIcon, InfoIcon, SettingsIcon, RepeatIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { routes } from '../../../constants/routes';
import { setAppStateAction } from '../../../modules/app/actions';
import { TokenService } from '../../../services/TokenService';
import { selectUserFirstName } from '../../../modules/user/selectors';

export const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const firstName = useAppSelector(selectUserFirstName);

  const handleClickLogo = () => {
    navigate(routes.MAIN);
    dispatch(setCarTypeAction(''));
  };

  const logout = () => {
    dispatch(setAppStateAction({ loading: false, logged: false }));
    TokenService.clearTokens();
  };

  return (
    <Box
      as="header"
      bg="white"
      p={4}
      position="fixed"
      top={0}
      w="100%"
      zIndex={1}
      height="90px"
      boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)"
    >
      <Flex align="center" justify="space-between" maxW="1316px" m="auto">
        <ChakraLink
          as={RouterLink}
          to={'/'}
          _hover={{ textDecoration: 'none' }}
          onClick={handleClickLogo}
        >
          <LogoMainImage />
        </ChakraLink>

        {/* <ButtonCustom variant="withoutBackground" bg="black">
          <BurgerMenuIcon />
        </ButtonCustom> */}

        <SearchBarWithResults />

        <Flex>
          <ChakraLink href={routes.ORDERS} mr={4} whiteSpace="nowrap">
            Мои заказы
          </ChakraLink>
          <ChakraLink href={routes.CATALOG_CART} mr={4}>
            Корзина
          </ChakraLink>

          <Menu>
            <MenuButton as={Button} variant="link">
              <Text ml={2} whiteSpace="nowrap" color="black" fontWeight="normal">
                {firstName || 'Профиль'}
              </Text>
            </MenuButton>
            <MenuList borderRadius="3xl" padding="12px">
              <MenuItem>
                <ChatIcon />
                Сообщения
              </MenuItem>
              <ChakraLink href={routes.TRANSACTIONS_HISTORY}>
                <MenuItem>
                  <InfoIcon />
                  Финансы
                </MenuItem>
              </ChakraLink>
              <ChakraLink href={routes.RETURNS}>
                <MenuItem>
                  <RepeatIcon />
                  Возвраты
                </MenuItem>
              </ChakraLink>
              <ChakraLink href={routes.SETTINGS}>
                <MenuItem>
                  <SettingsIcon />
                  Настройки
                </MenuItem>
              </ChakraLink>
              <Box width="100%" height="1px" backgroundColor="#00000014" />
              <ChakraLink onClick={logout}>
                <MenuItem>
                  <ArrowForwardIcon />
                  Выйти
                </MenuItem>
              </ChakraLink>
            </MenuList>
          </Menu>
        </Flex>
      </Flex>
    </Box>
  );
};
